import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/AuthContext";
import { loginApi } from "../../../api/auth";
import "./Login.css";
import axios from "axios";

const { Title } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const response = await loginApi(values);
     
      login({ username: values.username, userId: response.userId, accountType:response?.accountType, token: response.token });
      message.success("Đăng nhập thành công!");
      navigate("/tournament");
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        message.error(error.response?.data?.systemMessage || "Đăng nhập thất bại!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-left">
          <img src={require("../../../assets/Logo.png")} alt="Logo" className="login-logo" />
          <Title level={3}>Pickleball Arena</Title>
          <p>Chào mừng bạn đến với trang quản trị của Pickleball Arena</p>
          <p style={{ fontWeight: "600" }}>Đăng nhập</p>
          <Form name="login" layout="vertical" onFinish={onFinish}>
            <Form.Item name="username" rules={[{ required: true, message: "Vui lòng nhập tên đăng nhập!" }]}>
              <Input size="large" prefix={<UserOutlined />} placeholder="Tên đăng nhập" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Vui lòng nhập mật khẩu!" }]}>
              <Input.Password size="large" prefix={<LockOutlined />} placeholder="Mật khẩu" />
            </Form.Item>
            <Form.Item>
              <Link className="login-forgot" to="/forgot-password">
                Quên mật khẩu
              </Link>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-button" size="large" loading={loading}>
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="login-right" style={{ backgroundImage: `url(${require("../../../assets/image.png")})` }}></div>
      </div>
    </div>
  );
};

export default Login;
